export const initialFormState = {
    helpTextsById: {},
    isSubmitting: false
};
